import { Appointment } from "@myapp/contract";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { appointmentKeys } from "../appointment.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { appointmentApi } from "../service";
import { auditLogKeys } from "../../../audit-log";

/** "Anfahrt starten" — opens the work session; the phase derives from the stamped timestamp. */
export function useStartAppointmentTravel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, workOrderId }: { id: number; workOrderId?: string }) => {
      const { data } = await appointmentApi.startTravel(id);
      return { appointment: data as Appointment, workOrderId };
    },
    onSettled: (_data, _err, vars) => {
      queryClient.invalidateQueries({ queryKey: appointmentKeys.all });
      // The live banner and the calendar both read `GET /schedule` state.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      if (vars?.workOrderId) {
        queryClient.invalidateQueries({ queryKey: auditLogKeys.byWorkOrder(vars.workOrderId) });
      }
    },
  });
}
